import React, { Component } from 'react';
import './FeeTable.css'
import {gcolor} from './wtfutil';

class FeeTable extends Component {

  styler(x) {
    if(x == null || isNaN(x)) {
      return {
        "background": "grey",
        "textAlign": "center",
        "border": `1px solid rgba(255,255,255,0.5)`,
      }
    };

    const c = gcolor(x/800);

    return {
      "background": `hsl(${c[0]}, ${c[1]*100}%, ${c[2]*100}%)`,
      "border": `1px solid rgba(255,255,255,0.5)`,
    };
  }

  repr(x) {
    if(x == null || isNaN(x)) {
      return "NaN"
    }

    const approx = Math.exp(x/100);
    let r;

    if (this.props.fixed === 0) {
      r = Math.ceil(approx).toString();
    } else {
      r = Math.exp(x/100).toFixed(this.props.fixed)
    }

    return r;
  }

  reprColumn(x) {
    return (x * 100).toFixed(0) + '%'
  }

  reprIndex(x) {
    return x/6 + 'h';
  }

  render() {

    const df = this.props.dataframe

    const headers = df.columns.map((columnName) =>
      <th>{this.reprColumn(columnName)}</th>
    )
    const rows = df.index.map((index, i) => {
        const cells = df.data[i].map((cell) =>
          <td style={this.styler(cell)}>{this.repr(cell)}</td>
        )

        return (
          <tr>
            <th>{this.reprIndex(index)}</th>
            {cells}
          </tr>
        )
    }

    )

    return (
      <table className="FeeTable">
        <thead>
            <tr>
            <th></th>
            {headers}
            </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>

      </table>
    )
  }
}


FeeTable.defaultProps = {
  'fixed': 1,
}

export default FeeTable;



// WEBPACK FOOTER //
// ./src/FeeTable.js